import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative h-full min-h-screen" }
const _hoisted_2 = { class: "pt-10 px-10 flex justify-center align-middle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-4xl pt-3 px-1 text-black underline" }, "NFT", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-4xl pt-3 px-2 text-black underline" }, "ARMORY", -1)
const _hoisted_5 = { class: "p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNavBar = _resolveComponent("TheNavBar")!
  const _component_TheLogo = _resolveComponent("TheLogo")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_TheCat = _resolveComponent("TheCat")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_TheMobileCover = _resolveComponent("TheMobileCover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TheNavBar),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_TheLogo),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(_component_TheCat),
    _createVNode(_component_TheFooter),
    (_ctx.windowWidth < 800)
      ? (_openBlock(), _createBlock(_component_TheMobileCover, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}